/* eslint-disable no-loop-func */
export function isMultiText(result){
    return (
        result.type !=='select'
        && result.type !=='picklist'
        && result.type !=='date'
        && result.type !=='number'
        && result.condition !=='between'
    );
}
export function isNoValue(result){
    if(typeof result!=='object') return;
    return result.condition==='IS NULL' || result.condition==='NOT NULL';
}

function copyItem(item={}) {
    const newItem = {};
    for(var key in item){
        const prop = item[key];
        if(key === 'pickProps'){
        	const o = {};
            const keys = ['showKey', 'mainField', 'reverseMap', 'pickMap'];
            keys.forEach((k)=> o[k] = prop[k])
            newItem[key] = o;
        }else{
            newItem[key] = prop;
        }
    }
    return newItem;
}
export function getResults(results){
	return (results || []).map((result,index) => {
		const id = getIndexLabel(index);
		const o = copyItem(result);
		o.id = result.id = id;
		return o;
	});
}
function getMap(item){
    const props = item.pickProps;
    var map = props.pickMap;
    if(props.reverseMap){
        var newMap = {};
        for(var k in map){
            newMap[map[k]] = k;
        }
        map = newMap;
    }
    return map;
}
function getRelatedField(item) {
    var result = item.relateField;
    if(!result){
        var map = getMap(item) || {};
        if(map.hasOwnProperty('id') && map.id){
            result = map.id;
        }
    }
    return result;
}

const ID_PREFIX = 'comb_filter_';

/**
 * @method：makeFiltersRaw
 * @createdBy:HuangJian
 * @date:2019/1/16
 * @params：
 * results：字段筛选条件
 * filterOperator：字段逻辑条件
 * @description：用于生成fieldsRaw
 */
export function makeFiltersRaw(results, filterOperator){

	results = getResults(results);

	const items = [];

	/*防止在给filtersRaw条目id加前缀时被替换,后面会有一步还原操作*/
	filterOperator = filterOperator.replace(/AND/g, '&&').replace(/OR/g, '||');

	results.forEach((result)=> {


		/*给filtersRaw的条目的id加上前缀*/
		const idTarget = `${ID_PREFIX}${result.id}`;
		filterOperator = filterOperator.replaceAll(result.id, idTarget);
		result.id = idTarget;

		/*多字段筛选*/
		if(result.multi){
			items.push({
				result,
				filter: [{
					property: `[${result.field}]`,
					operator: result.condition,
					value: result.value
				}]
			});
		/*单字段筛选*/
		}else {
			/*picklist类型*/
			if(result.type === 'picklist'){
				let keyField = result.isLink ? result.pickProps.showKey : result.pickProps.mainField;
				const relateField = getRelatedField(result);
				if(relateField){
					result.field = relateField;
					keyField = 'id';
				}
				/*多选*/
				if(result.multival){
					result.values = (result.values || []).map((v) => v[keyField] || v[relateField] || '');
				/*单选*/
				}else {
					const pickValue = result.pickval || {};
					result.value = pickValue[keyField] || pickValue[relateField] || '';
				}
			}

			/*普通字段多值*/
			if(result.multival){
				/*文本多值*/
				if(isMultiText(result)){
					result.values = (result.value || '')
						.replaceAll('，', ',')
						.split(',')
						.filter((s)=> s);
				}
			}

			/*区间类型的条件生成*/
			if(result.condition==='between'){
				if(result.type === 'date'){
					const start = {
						property: result.field,
						operator: '>=',
						value: result.values[0]
					}
					const end = {
						property: result.field,
						operator: '<=',
						value: result.values[1]
					}
					items.push({result, filter: [start, end]});
				}

				if(result.type === 'number'){
					const start = {
						property: result.field,
						operator: '>=',
						value: result.start
					}
					const end = {
						property: result.field,
						operator: '<=',
						value: result.end
					}
					items.push({result, filter: [start, end]});
				}
			}else {
				const filter = {
					property: result.field,
					operator: result.condition,
					value: result.multival ? `[${result.values}]`:result.value
				};
				if(isNoValue(result)){
					filter.value = ''
				}
				items.push({result, filter: [filter]});
			}
		}
	});

	let filtersRaw = [];

	/*特殊处理*/
	items.forEach(({result, filter})=> {
		/*处理日期范围值*/
		if(result.type === 'date'){
			filter.forEach((t)=> {
				if(['>', '>='].includes(t.operator)){
					t.value += ' 00:00:00';
				}else if(['<', '<='].includes(t.operator)){
					t.value += ' 23:59:59';
				}
			});
		}

		/*处理逻辑条件的ID*/
		if(filter.length > 1){
			const ids = filter.map((t,i)=> {
				t.id = `${result.id}_${i}`;
				return t.id;
			}).join(' && ');
			if(filterOperator) {
				filterOperator = filterOperator.replaceAll(result.id, `(${ids})`);
			}
		}else {
			(filter[0] || {}).id = result.id;
		}

		filtersRaw = filtersRaw.concat(filter);
	});

	/*还原逻辑关键字*/
	filterOperator = filterOperator.replace(/&&/g, 'AND').replace(/\|\|/g, 'OR');

    return {filtersRaw, filterOperator};
}

const LABELS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export function getIndexLabel(index){
	const lindex = index % LABELS.length;
	const sindex = Math.floor(index / LABELS.length);
	return `${LABELS.charAt(lindex)}${sindex || ''}`;
}

const KEY_WORD_MAP = {
	AND: [/AND/g, /且/g, /&&/g, /&/g],
	OR: [/OR/g, /或/g, /\|\|/g, /\|/g]
}

export function getLogicOperator(s){
	s = (s || '').toUpperCase();
	s = s.replace(/（/g, '(');
	s = s.replace(/）/g, ')');
	Object.keys(KEY_WORD_MAP).forEach((opr)=> {
		KEY_WORD_MAP[opr].forEach((word)=>{
			s = s.replace(word, ` ${opr} `);
		});
	})
	s = s.replace(/\s+/g, ' ').trim();
	return s;
}

export function getLineErrorMsg(fm){
	const wrongField = (fm.fields || []).find((t)=>{
		let msg = '';
		t.validate('', (s)=> msg = s);
		return Boolean(msg);
	});
	if(!wrongField) return '';
	const prop = wrongField.prop;
	if(prop === 'field'){
		return  '未选择字段';
	}else if (prop === 'condition'){
		return '未选择筛选方式';
	}else if (['value', 'values'].includes(prop)){
		return '缺少筛选值';
	}
	return '';
}

export function checkBrackets(s){
	const chars = (s || '').split('');
	const stack = [];
	for (let i in chars){
		let c = chars[i];
		if(c === '('){
			stack.push(i);
		}else if(c === ')'){
			if(stack.pop() === undefined) return false;
		}
	}
	return stack.length === 0;
}


export function checkFormat(s){
	const exps = [];
	let chars = (s || '').split('');
	do {
		let start = 0;
		let end = chars.length;
		for (let i =0;i<chars.length;i++){
			const c = chars[i];
			if(c === '('){
				start = i;
			}else if(c === ')'){
				end = i + 1;
				break;
			}
		}
		const p = [start, end - start];
		if(end<=chars.length) p.push('$', exps.length);
		let exp = [].splice.apply(chars, p).join('');
		exp = exp.replace(/\(|\)/g, '');
		exps.push(exp);
		if(/^\$\d$/.test(chars.join(''))) break;
	}while (chars.length);
	return exps.every((e)=> /^[A-Z\$]\d*(\s+(&|\|)\s+[A-Z\$]\d*)*$/.test(e));
}
